import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useFeatureFlagsReady } from './useFeatureFlagsReady';
import { FlagState } from '../types/FlagState';
import { validateFeatureFlagName } from '../constants';

export function useFeatureFlag<TValue = unknown>(featureFlag: string, defaultValue?: TValue): FlagState<TValue> {
  const ready = useFeatureFlagsReady();
  const flagState = useFlags();

  validateFeatureFlagName(featureFlag);

  const value = (flagState[featureFlag] ?? defaultValue ?? false) as TValue;

  return useMemo(() => ({ enabled: !!value, value, ready }), [value, ready]);
}
